import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=5f20938f&scoped=true&"
import script from "./Vision.vue?vue&type=script&lang=ts&"
export * from "./Vision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20938f",
  null
  
)

export default component.exports